import { render } from "./ModuleStyleguideNav.vue?vue&type=template&id=79118256"
import script from "./ModuleStyleguideNav.vue?vue&type=script&lang=js"
export * from "./ModuleStyleguideNav.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__